/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  
  LOAD_REJECT_LIST,
  LOAD_REJECT_LIST_SUCCESS,
  LOAD_REJECT_LIST_ERROR,


  LOAD_LEAD_CONVERT_LIST,
  LOAD_LEAD_CONVERT_LIST_SUCCESS,
  LOAD_LEAD_CONVERT_LIST_ERROR,

  LOAD_LEAD_REJECT_LIST,
  LOAD_LEAD_REJECT_LIST_SUCCESS,
  LOAD_LEAD_REJECT_LIST_ERROR,




} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(obsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    obsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRejectList(searchFilter,reject) {
  return {
    type: LOAD_REJECT_LIST,
    searchFilter,reject
  }
}

export function loadRejectListSuccess(rejected_list) {
  return {
    type: LOAD_REJECT_LIST_SUCCESS,
    rejected_list,
  }
}

/**
 * @param {string} error
 */

export function loadRejectListError(error) {
  return {
    type: LOAD_REJECT_LIST_ERROR,
    error,
  }
}


export function loadLeadConvertedList(searchFilter) {
  return {
    type: LOAD_LEAD_CONVERT_LIST,
    searchFilter
  }
}

export function loadLeadConvertedListSuccess(converted_list) {
  return {
    type: LOAD_LEAD_CONVERT_LIST_SUCCESS,
    converted_list,
  }
}

/**
 * @param {string} error
 */

export function loadLeadConvertedListError(error) {
  return {
    type: LOAD_LEAD_CONVERT_LIST_ERROR,
    error,
  }
}

export function loadLeadRejectedList(searchFilter) {
  return {
    type: LOAD_LEAD_REJECT_LIST,
    searchFilter
  }
}

export function loadLeadRejectedListSuccess(leadrejected_list) {
  return {
    type: LOAD_LEAD_REJECT_LIST_SUCCESS,
    leadrejected_list,
  }
}


export function loadLeadRejectedListError(error) {
  return {
    type: LOAD_LEAD_REJECT_LIST_ERROR,
    error,
  }
}



const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  //Leave list
  loadRejectList,
  loadRejectListSuccess,
  loadRejectListError,
  
  
  loadLeadConvertedList,
  loadLeadConvertedListError,
  loadLeadConvertedListSuccess,

  loadLeadRejectedList,
  loadLeadRejectedListSuccess,
  loadLeadRejectedListError

}

export default actions
